import {ActionTree, MutationTree} from 'vuex';
import {RootState} from '@/store/types';
import api from "@/service/api";
import VueI18n from '../../helpers/i18n';
import store from '@/store'


export interface State {
    badges: any;
    loadingBadgesByImport: boolean;
    loadingBadges: boolean;
    loadingBadge: boolean;
    count: number;
    badge: any;
    badgesByImport: any;
    codeInvite:null|string;
    loadingCodeInvite:boolean;
    filterStandman:any;
    addCompanyMemberLoading:boolean;

}

const defaultState: State = {
    filterStandman:null,
    codeInvite:null,
    loadingCodeInvite:false,
    badges: [],
    loadingBadgesByImport: false,
    loadingBadges: false,
    loadingBadge: false,
    addCompanyMemberLoading:false,
    count: 0,
    badge: {},
    badgesByImport: [],
};

const getters = {
    getFilterStandman(state: State){
        if(!state.filterStandman) return
        VueI18n.locale = store.state.locale.locale
        let map = state.filterStandman.map((el:any) => {
            return {id: el._id, text: el.name}
        }).sort((x:any,y:any)=>{
            return x.text.localeCompare(y.text);
        })
        map.unshift({id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all').toString()})
        return map
    },
    loadingCodeInvite: (state: State) => state.loadingCodeInvite,
    addCompanyMemberLoading: (state: State) => state.addCompanyMemberLoading,
    codeInvite: (state: State) => state.codeInvite,
    loadingBadgesByImport: (state: State) => state.loadingBadgesByImport,
    loadingBadges: (state: State) => state.loadingBadges,
    loadingBadge: (state: State) => state.loadingBadge,
    badges: (state: State) => state.badges,
    badgeByImport: (state: State) => state.badgesByImport,
    count: (state: State) => state.count,
    badge: (state: State) => state.badge,
    badgesMap(state: State) {
        VueI18n.locale = store.state.locale.locale
        let map = state.badges.map((el:any) => {
            return {id: el.userParticipation_id, text: el.last + ' ' + el.first}
        }).sort((x:any,y:any)=>{
            return x.text.localeCompare(y.text);
        })
        map.unshift({id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all').toString()})
        return map
    },
};

const mutations: MutationTree<State> = {

    setFilterStandmen(state:State, payload){
        state.filterStandman = payload
    },
    addBadges(state:State, payload){
        let help = payload.map((member: any) => {
            return {
                first: member.userParticipation.name.first,
                last: member.userParticipation.name.last,
                first_last:member.userParticipation.name.first + ' ' +member.userParticipation.name.last ,
                position:member.userParticipation.position || ' - ',
                email:member.userParticipation.contacts.filter((el:any)=>el.type == 'email').length ? member.userParticipation.contacts.filter((el:any)=>el.type === 'email')[0].value: ' - ',
                phone:member.userParticipation.contacts.filter((el:any)=>el.type == 'phone').length ? member.userParticipation.contacts.filter((el:any)=>el.type === 'phone')[0].value: ' - ',
                login: member.user.login,
                user_id: member._id,
                user_created: member.userParticipation.metadata.createdAt,
                userParticipation_id: member.userParticipation._id,
                userParticipation_status: member.userParticipation.status,
                userParticipation_barcode: member.userParticipation.barcode,
            }})
      state.badges = [...state.badges, ...help]
    },
    deleteBadge(state: State, payload: any) {
        state.badges = state.badges.filter((el:any)=>el.userParticipation_id !== payload)
    },
    setBadges(state: State, payload: any) {
        state.badges = payload
    },
    setBadge(state: State, payload: any) {
        state.badge = payload
    },
    setCount(state: State, payload: any) {
        state.count = payload
    },
    normalize(state: State, payload: any) {
        state.badges = payload.map((member: any) => {
            return {
                first: member.userParticipation.name.first,
                last: member.userParticipation.name.last,
                first_last:member.userParticipation.name.first + ' ' +member.userParticipation.name.last ,
                position:member.userParticipation.position || ' - ',
                email:member.userParticipation.contacts.filter((el:any)=>el.type == 'email').length ? member.userParticipation.contacts.filter((el:any)=>el.type === 'email')[0].value: ' - ',
                phone:member.userParticipation.contacts.filter((el:any)=>el.type == 'phone').length ? member.userParticipation.contacts.filter((el:any)=>el.type === 'phone')[0].value: ' - ',
                login: member.user.login,
                user_id: member._id,
                user_created: member.userParticipation.metadata.createdAt,
                userParticipation_id: member.userParticipation._id,
                userParticipation_status: member.userParticipation.status,
                userParticipation_barcode: member.userParticipation.barcode,
                trusted:member.userParticipation.showBadgeContactsInEmail,
                load:false
            }
        })
    },
    normalizeByImport(state: State, payload: any) {
        state.badgesByImport = payload.map((member: any) => {
            return {
                login: member.user.login,
                user_id: member._id,
                first_last:member.user.firstName + ' ' +member.user.lastName ,
            }
        })
    },
    clearModule(state: State) {
        state.loadingBadges = false
        state.loadingBadgesByImport = false
        state.badges = []
        state.badgesByImport = []
        state.count = 0
    },
    pathLoad(state:State,payload){
        console.log(payload)
        state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].load =payload.load;

    },
    patchBadges(state:State,payload){
       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].first = payload.name.first;
       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].last = payload.name.last;
       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].first_last = payload.name.first +' ' + payload.name.last;

       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].position = payload.position;
       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].load = false;
       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].trusted = payload.showBadgeContactsInEmail;
       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].email = payload.contacts.filter((el:any)=>el.type == 'email').length ? payload.contacts.filter((el:any)=>el.type === 'email')[0].value: ' - ';
       state.badges.filter((el: any) => el.userParticipation_id === payload._id)[0].phone = payload.contacts.filter((el:any)=>el.type == 'phone').length ? payload.contacts.filter((el:any)=>el.type === 'phone')[0].value: ' - ';



    },
    setCodeInvite(state:State,payload:any){
        state.codeInvite = payload
    }

};


const actions: ActionTree<State, RootState> = {
    async refreshCodeInvite({state, commit}, payload) {
        try {
            state.loadingCodeInvite = true
            const {data} = await api.go('refreshCodeInvite', payload)
            commit('setCodeInvite',data.data.companyCodeInvite.code)

            state.loadingCodeInvite = false
        } catch (e) {
            //@TODO бработка ошибки
            this.commit('dialog/SetModalError', {show: true, error: 'notSave'})
            commit('setCodeInvite',null)
            state.loadingCodeInvite = false
        } finally {
            state.loadingCodeInvite = false
        }
    },
    async getCodeInvite({state, commit}, payload) {

        try {
            state.loadingCodeInvite = true
            const {data} = await api.go('getCodeInvite', payload)
            commit('setCodeInvite',data.data.companyCodeInvite.code)

            state.loadingCodeInvite = false
        } catch (e) {
            //@TODO бработка ошибки
            commit('setCodeInvite',null)
            state.loadingCodeInvite = false
        } finally {
            state.loadingCodeInvite = false
        }
    },
    async getCompanyMembers({state, commit}, payload) {
        try {
            state.loadingBadges = true
            const {data} = await api.go('getCompanyMembers', {
                params: payload.params,
                query: payload.query
            })
            commit('normalize', data.data.models)
            commit('setCount', data.data.count)
            state.loadingBadges = false
        } catch (e) {
            //@TODO бработка ошибки
            state.loadingBadges = false
        } finally {
            state.loadingBadges = false
        }
    },
    async getCompanyMembersFromFilter({state, commit}, payload) {
        try {
            state.loadingBadges = true
            const {data} = await api.go('getCompanyMembersFromFilter', {
                params: payload.params,
                query: payload.query
            })

            commit('setFilterStandmen', data.data.standmen)
            // commit('normalize', data.data.models)
            // commit('setCount', data.data.count)
            state.loadingBadges = false
        } catch (e) {
            //@TODO бработка ошибки

        } finally {
            state.loadingBadges = false
        }
    },
    async getCompanyMembersByImport({state, commit}, payload) {
        try {
            state.loadingBadgesByImport = true
            const {data} = await api.go('getCompanyMembers', {
                params: payload.params,
                query: payload.query
            })
            commit('normalizeByImport', data.data.models)
            // commit('setCount', data.data.count)
            state.loadingBadgesByImport = false
        } catch (e) {
            state.loadingBadgesByImport = false
        } finally {
            state.loadingBadgesByImport = false
        }
    },
    async getCompanyMember({state, commit}, payload) {
        try {
            state.loadingBadge = true
            const {data} = await api.go('getCompanyMember', {
                params: payload,
            })
            commit('setBadge', data.data.badge)
            state.loadingBadge = false
        } catch (e) {
            state.loadingBadge = false
        } finally {
            state.loadingBadge = false
        }
    },
    async patchCompanyMember({state, commit}, payload) {
        try {
            let payload2:any = {}
            payload2._id = payload.params.badgeId
            payload2.load = true
            commit('pathLoad', payload2)
            const {data} = await api.go('patchCompanyMember', {
                params: payload.params,
                body: payload.body,
            })
           commit('setBadge', {...data.data.badge,load:false})
           commit('patchBadges',data.data.badge)
        } catch (e) {
            this.commit('dialog/SetModalError', {show: true})
        } finally {
            commit('pathLoad', {
                _id : payload.params.badgeId,
                load : false
            })
        }
    },
    async addCompanyMember({state, commit}, payload) {
        try {
            state.addCompanyMemberLoading = true
            const {data} = await api.go('addCompanyMember', {
                params: payload.params,
                body: payload.body,
            })
           commit('addBadges',data.data.companyMembers)
        } catch (e) {
            this.commit('dialog/SetModalError', {show: true})
        } finally {
            state.addCompanyMemberLoading = false
        }
    },
    async deactivateCompanyMember({state, commit}, payload) {
        try {
           await api.go('deactivateCompanyMember', {
                params: payload.params
            })
            commit('deleteBadge',payload.params.badgeId)
        } catch (e) {
            this.commit('dialog/SetModalError', {show: true})
        } finally {
        }
    },

};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions,
};
